import { Translations } from './translations'

export const ko: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: '설정',

  // Resources
  resources: '리소스',
  money: '돈',
  energy: '에너지',
  compute: '컴퓨팅',
  quality: '품질',
  totalUsers: '총 사용자',
  price: '가격',
  research: '연구',

  // Actions
  train: '훈련',
  trainCost: '비용',
  qualityGain: '품질',
  inference: '추론',
  needUsers: '사용자 필요!',
  usersWaiting: '사용자 대기중',
  qualityToAttract: '품질 > 40% 필요',
  researchAction: '연구',
  unlocksAfter: '이후 해제:',
  computeSpent: '컴퓨팅 사용',
  cost: '비용',
  compShort: '컴퓨',
  energyShort: '에너',

  // Hardware
  hardware: '하드웨어',
  computePerSec: '컴퓨팅/초',
  usesEnergy: '사용',
  devicesTotal: '총 장치',

  // Models
  training: '훈련',
  yourModels: '당신의 모델',
  params: '파라미터',
  maxUsers: '최대 사용자',
  trainCost2: '훈련 비용',
  unlocked: '해제됨',
  researchPoints: '연구',

  // Upgrades
  upgrades: '업그레이드',
  upgradesLockedMsg: '모델을 50% 품질까지 훈련하여 업그레이드 해제',
  max: '최대',
  all: '모두',
  
  // Upgrade tiers
  tierGarage: '차고',
  tierGarageDesc: '시작',
  tierStartup: '스타트업',
  tierStartupDesc: 'GPT-1 시대',
  tierScaleUp: '확장',
  tierScaleUpDesc: 'GPT-2/3 시대',
  tierEnterprise: '엔터프라이즈',
  tierEnterpriseDesc: 'ChatGPT 시대',
  tierHyperscale: '하이퍼스케일',
  tierHyperscaleDesc: 'GPT-4 시대',
  tierGlobal: '글로벌',
  tierGlobalDesc: '경쟁 시대',
  tierSuperintelligence: '초지능',
  tierSuperintelligenceDesc: 'GPT-5+ 시대',
  tierSingularity: '특이점',
  tierSingularityDesc: 'AGI/ASI 시대',

  // Footer
  computeSpentStat: '컴퓨팅 사용량',
  time: '시간',
  resetGame: '게임 재설정',
  resetConfirm: '모든 진행을 재설정하시겠습니까?',
  pause: '일시 중지',
  resume: '재개',

  // Event Log
  eventLog: '이벤트 로그',
  welcome: 'GPT Clicker에 오신 것을 환영합니다! 시작하려면 모델을 훈련하세요.',

  // Price
  market: '시장',
  pricePerMillion: '$/백만 토큰',

  // Tags
  tagEnergy: '에너',
  tagCompute: '컴퓨',
  tagHw: 'HW',
  tagTrain: '훈련',
  tagResearch: '연구',
  tagAuto: '자동',

  // Tutorial messages
  tutorialWelcome: '2020년. 당신은 트랜스포머 아키텍처 기반의 작은 언어 모델을 훈련하려고 합니다.',
  tutorialFirstTrain: '훈련 시작! 당신의 노트북이 에너지를 컴퓨팅으로 변환합니다. 각 훈련이 모델의 품질을 개선합니다.',
  tutorialQuality20: '모델이 기본 패턴을 학습하고 있습니다. 품질을 개선하려면 훈련을 계속하세요.',
  tutorialQuality40: '품질 40% 이상! 당신의 모델은 이제 꽤 일관성 있는 텍스트를 생성할 수 있습니다. 사용자들이 주목하기 시작합니다...',
  tutorialQuality50: '업그레이드 해제! 당신의 수익으로 더 나은 하드웨어를 구입하고 에너지 용량을 확장하세요.',
  tutorialFirstUsers: '당신의 첫 사용자! 추론을 클릭하여 요청을 처리하고 돈을 버세요.',
  tutorialUsers10: '소문이 퍼집니다. 더 많은 사용자가 당신의 모델을 시도하고 있습니다. 가격을 올리는 것을 고려하세요...',
  tutorialMoney100: '$100이 있습니다! 하드웨어를 업그레이드할 시간입니다. 더 나은 GPU = 더 많은 컴퓨팅 = 더 빠른 훈련.',
  tutorialMoney1k: '당신의 작은 AI 프로젝트가 진정한 비즈니스가 되고 있습니다. 투자자들이 전화하기 시작합니다...',
  tutorialResearchUnlock: '연구 해제! 연구에 컴퓨팅을 사용하여 더 크고 강력한 모델을 해제하세요.',
  tutorialFirstResearch: '연구 포인트가 축적됩니다. 충분히 모으면 다음 모델 아키텍처를 해제할 수 있습니다.',
  tutorialGpt2Small: 'GPT-2 Small 해제! 이 아키텍처는 더 복잡한 작업을 처리할 수 있습니다. 처음부터 훈련하세요.',
  tutorialGpt2Large: 'GPT-2 Large! 사람들이 "릴리스하기에는 너무 위험하다"고 말합니다...',
  tutorialGpt3: 'GPT-3 시대가 시작됩니다. Few-shot 학습이 모든 것을 바꿉니다. 세계가 보고 있습니다.',
  tutorialGpt4: 'GPT-4가 여기입니다. 멀티모달, 추론, 그리고 무섭도록 능력이 있습니다. AI 경쟁이 심화됩니다.',
  tutorialAgi: '해냈습니다. AGI가 여기입니다. 이해합니다. 자신을 개선합니다. 그 이후는 당신에게 달려있습니다...',
  tutorialHwGaming: '멋진 GPU! 훈련이 훨씬 빨라집니다. 당신의 이웃들이 전기 요금에 대해 불평할 수 있습니다.',
  tutorialHwServer: '진정한 서버 랙! 차고를 벗어났습니다. 이제 사무실 공간을 임대해야 합니다.',
  tutorialHwDatacenter: '당신의 데이터센터! 이제 대형 기술 회사들과 경쟁하고 있습니다.',
  tutorialHwSatellite: '궤도 컴퓨팅! Moonlink 성좌는 우주에서 전례없는 처리 능력을 제공합니다.',
  tutorialHwQuantum: '양자 우위 달성. QC-1024는 아인슈타인을 불안하게 만들 원리로 작동합니다.',
  tutorialUsers100: '100명 사용자! 견인력을 얻고 있습니다. 기술 블로그가 당신에 대해 쓰고 있습니다.',
  tutorialUsers1k: '1,000명 사용자! 지원 팀을 고용해야 합니다. 그리고 아마도 일부 변호사들.',
  tutorialUsers100k: '100K명 사용자! 이제 유니콘 스타트업입니다. VC들이 당신에게 돈을 주기 위해 싸우고 있습니다.',
  tutorialUsers1m: '백만 사용자! 인류가 기술과 상호작용하는 방식을 바꾸고 있습니다.',

    // Model descriptions
     modelTinyDesc: '겸손한 시작. 거의 일관성 없음, 하지만 작동합니다.',
   modelGpt2SmallDesc: '모든 것을 시작한 모델. 정말 유용합니다.',
   modelGpt2LargeDesc: '릴리스하기에는 너무 위험합니다... 정말로?',
   modelGpt3Desc: 'Few-shot 학습. 세계가 주목합니다.',
   modelGpt4Desc: '멀티모달. 추론. 군비 경쟁이 시작됩니다.',
   modelAgiDesc: '이해합니다. 자신을 개선합니다. 다음은?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: '겸손한 시작. 변압기 아키텍처가 탄생합니다.',
   modelGpt1Desc: '생성적 사전 교육. 언어 모델이 배울 수 있습니다!',
   modelGpt2Desc: '릴리스하기에는 너무 위험합니다... 정말로?',
   modelGpt35Desc: 'RLHF 마법. ChatGPT가 하루 만에 바이럴됩니다.',
   modelGpt41Desc: '더 빠르고 저렴하며 더 좋습니다. 반복 게임.',
   modelU1Desc: '야생 경쟁자가 나타납니다. 추론의 돌파구.',
   model2UDesc: '속편. 스테로이드의 사고의 체인.',
   modelGpt5Desc: '박사 수준의 추론. 과학자들이 긴장합니다.',
   modelGpt6Desc: '대부분의 엔지니어보다 더 나은 코드를 작성합니다. 모든 이전 모델이 중단되었습니다.',
   modelGpt7Desc: '인공 일반 능력을 달성했습니다.',
   modelAgi1Desc: '이해합니다. 배웁니다. 자신을 개선합니다.',
   modelAgi2Desc: '재귀적 자기 개선. 특이점이 다가오고 있습니다.',
   modelAgi3Desc: '최종 AGI 반복. 초월을 위한 준비.',
   modelAsiDesc: '인공 초지능. 특이점이 여기 있습니다.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: '노트북 오버클록',
  upgradeLaptopOverclockDesc: '노트북을 더 강력하게: +2 컴퓨팅/초',
  upgradeBetterOutlet: '더 나은 콘센트',
  upgradeBetterOutletDesc: '+50 최대 에너지',
  upgradeSolarPanel: '태양판',
  upgradeSolarPanelDesc: '+1 에너지/초 회복',
  upgradePowerGrid: '전력망 연결',
  upgradePowerGridDesc: '+5 에너지/초 회복',
  upgradeNuclearPlant: '원자력 발전소',
  upgradeNuclearPlantDesc: '+20 에너지/초 회복',
  upgradeFusionReactor: '핵융합 반응로',
  upgradeFusionReactorDesc: '+100 에너지/초 회복',
  upgradeDysonSphere: '다이슨 구',
  upgradeDysonSphereDesc: '+1000 에너지/초 회복',
  upgradeRamUpgrade: 'RAM 업그레이드',
  upgradeRamUpgradeDesc: '+50 최대 컴퓨팅',
  upgradeSsdArray: 'SSD 배열',
  upgradeSsdArrayDesc: '+200 최대 컴퓨팅',
  upgradeBetterOptimizer: '더 나은 옵티마이저',
  upgradeBetterOptimizerDesc: '+20% 훈련 효율',
  upgradeResearchPapers: '연구 논문',
  upgradeResearchPapersDesc: '+20% 연구 효율',
  upgradeSelfServicePortal: '셀프서비스 포털',
  upgradeSelfServicePortalDesc: '사용자가 스스로 처리: 0.5 자동 추론/초',
  upgradeApiAccess: 'API 접근',
  upgradeApiAccessDesc: '개발자가 모델을 통합: +1 자동 추론/초',
  upgradeMobileApp: '모바일 앱',
  upgradeMobileAppDesc: '이동 중인 사용자: +2 자동 추론/초',
  upgradeEnterpriseTier: '엔터프라이즈 티어',
  upgradeEnterpriseTierDesc: '대형 클라이언트, 대량 사용: +5 자동 추론/초',
  upgradeGlobalCdn: '글로벌 CDN',
  upgradeGlobalCdnDesc: '전 세계 낮은 지연: +10 자동 추론/초',
  upgradeBasicChatbot: '기본 챗봇',
  upgradeBasicChatbotDesc: '간단한 웹 위젯: +0.2 자동 추론/초',
  upgradeBulkApi: '대량 API',
  upgradeBulkApiDesc: '높은 용량 배치 처리: +3 자동 추론/초',
  upgradeNeuralEdge: '신경 엣지 네트워크',
  upgradeNeuralEdgeDesc: '엣지에서의 AI: +20 자동 추론/초',
  upgradeQuantumInference: '양자 추론',
  upgradeQuantumInferenceDesc: '양자 가속 추론: +50 자동 추론/초',
  upgradeOmnipresentAi: '편재하는 AI',
  upgradeOmnipresentAiDesc: '모든 곳, 모든 시간에 AI: +100 자동 추론/초',
  upgradeTrainingScheduler: '훈련 스케줄러',
  upgradeTrainingSchedulerDesc: '자동 훈련 실행: +0.1 자동 훈련/초',
  upgradeTrainingPipeline: '훈련 파이프라인',
  upgradeTrainingPipelineDesc: '지속적 훈련: +0.2 자동 훈련/초',
  upgradeMlOpsPlatform: 'MLOps 플랫폼',
  upgradeMlOpsPlatformDesc: '완전 자동화: +0.5 자동 훈련/초',
  upgradeNeuralArchitectureSearch: '신경 아키텍처 탐색',
  upgradeNeuralArchitectureSearchDesc: 'AI가 AI 훈련: +1 자동 훈련/초',
  upgradeSelfImprovingTraining: '자기 개선 훈련',
  upgradeSelfImprovingTrainingDesc: '재귀적 개선: +2 자동 훈련/초',
  upgradeResearchIntern: '연구 인턴',
  upgradeResearchInternDesc: '입문급 도움: +0.1 자동 연구/초',
  upgradeResearchTeam: '연구 팀',
  upgradeResearchTeamDesc: '전담 연구원: +0.2 자동 연구/초',
  upgradeResearchDivision: '연구 부서',
  upgradeResearchDivisionDesc: '완전 부서: +0.5 자동 연구/초',
  upgradeAiResearchLab: 'AI 연구 랩',
  upgradeAiResearchLabDesc: 'AI 지원 발견: +1 자동 연구/초',
  upgradeAutonomousResearch: '자율 연구',
  upgradeAutonomousResearchDesc: 'AI가 연구 수행: +2 자동 연구/초',
  upgradeAntimatterReactor: '반물질 반응로',
  upgradeAntimatterReactorDesc: '+10000 에너지/초 회복',
  upgradePhDScientists: '박사 과학자',
  upgradePhDScientistsDesc: '최고 인재 고용: +200% 연구 효율',
  upgradeResearchLab: '연구 랩',
  upgradeResearchLabDesc: '전담 시설: +500% 연구 효율',
  upgradeAiResearchAssistant: 'AI 연구 보조원',
  upgradeAiResearchAssistantDesc: 'GPT-4가 연구 지원: +1000% 연구 효율',
  upgradeAiScientist: 'AI 과학자',
  upgradeAiScientistDesc: 'AI가 자율적으로 실험 수행: +2000% 연구 효율',
  upgradeResearchSwarm: 'AI 연구 떼',
  upgradeResearchSwarmDesc: '수천 명의 AI 연구원: +5000% 연구 효율',
  upgradeRecursiveResearch: '재귀적 자기 개선',
  upgradeRecursiveResearchDesc: 'AI가 AI 개선: +10000% 연구 효율',
  upgradeSingularityResearch: '특이점 연구',
  upgradeSingularityResearchDesc: '이해를 초월: +50000% 연구 효율',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: '중고 GPU: +3 연산/초',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: '게이밍 GPU: +8 연산/초',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: '프로 GPU: +20 연산/초',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: '워크스테이션: +50 연산/초',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: '서버 랙 (4x A100): +120 연산/초',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'GPU 클러스터 (8x H100): +300 연산/초',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: '엣지 데이터센터: +800 연산/초',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: '데이터센터: +2K 연산/초',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: '메가 데이터센터: +5K 연산/초',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: '글로벌 네트워크: +15K 연산/초',
  upgradeHwSupercomputer: 'Frontier X1 슈퍼컴퓨터',
  upgradeHwSupercomputerDesc: '슈퍼컴퓨터: +50K 연산/초',
  upgradeHwSatellite: 'SkyNet Moonlink 성좌',
  upgradeHwSatelliteDesc: '궤도 위성: +200K 연산/초',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: '양자 컴퓨터: +1M 연산/초',
  upgradeHwDysonCompute: '다이슨 연산 구체',
  upgradeHwDysonComputeDesc: '항성 규모 연산: +10M 연산/초',
  upgradeHwMatrioshka: '마트료시카 뇌',
  upgradeHwMatrioshkaDesc: '은하 규모 연산: +100M 연산/초',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: '중고 GPU: +3 컴퓨팅/초',
  hwGamingGpuDesc: '게이밍 GPU: +8 컴퓨팅/초',
  hwProGpuDesc: '전문용 GPU: +20 컴퓨팅/초',
  hwWorkstationDesc: '워크스테이션: +50 컴퓨팅/초',
  hwServerRackDesc: '서버 랙 (4x A100): +120 컴퓨팅/초',
  hwGpuClusterDesc: 'GPU 클러스터 (8x H100): +300 컴퓨팅/초',
  hwMiniDatacenterDesc: '엣지 데이터센터: +800 컴퓨팅/초',
  hwDatacenterDesc: '데이터센터: +2K 컴퓨팅/초',
  hwMegaDatacenterDesc: '메가 데이터센터: +5K 컴퓨팅/초',
  hwDatacenterNetworkDesc: '글로벌 네트워크: +15K 컴퓨팅/초',
   hwSupercomputerDesc: '슈퍼컴퓨터: +50K 컴퓨팅/초',
   hwSatelliteDesc: '궤도 위성: +200K 컴퓨팅/초',
   hwQuantumDesc: '양자컴퓨터: +1M 컴퓨팅/초',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: '구매됨',
  switchedTo: '훈련으로 전환',
  unlockedModel: '해제됨',
  scalesToUsers: '확장 범위',
  trainItToAttract: '사용자. 사용자를 끌어들이려면 훈련하세요!',
  unlimited: '무제한',
  language: '언어',
  
  // Mobile labels
  mobileResources: '리소스',
  mobileModels: '모델',
  mobileHardware: '하드웨어',
  mobileUpgrades: '업그레이드',
  sell: '판매',
  sellFor: '판매 가격',
  discontinueConfirm: '{model}을 중단하시겠습니까? 사용자가 다른 모델로 마이그레이션됩니다.',
  autoInference: '자동 추론',
  autoInferenceRate: '자동 추론',
  autoTrain: '자동 훈련',
  autoTrainRate: '자동 훈련',
  autoResearch: '자동 연구',
  autoResearchRate: '자동 연구',

  // Tooltips
  tooltipTitle: 'GPT Clicker - AI 모델 훈련, 사용자 서빙, AI 제국 구축!',
  tooltipMoney: '돈 - 사용자 추론에서 얻음. 업그레이드와 하드웨어 구매에 사용.',
  tooltipEnergy: '에너지 - 시간에 따라 회복. 하드웨어에 컴퓨팅을 생성하기 위한 전원 공급.',
  tooltipCompute: '컴퓨팅 - 하드웨어에서 생성. 훈련, 추론, 연구에 사용.',
  tooltipResearch: '연구 포인트 - 컴퓨팅을 사용하여 RP 획득. RP를 사용하여 새로운 AI 모델 해제.',
  tooltipUsers: '사용자 - 모델 품질에 의해 끌어들여짐. 더 많은 사용자 = 추론 당 더 많은 수익.',
  tooltipComputeSpent: '총 컴퓨팅 사용량 - 훈련 및 연구에 사용된 총 컴퓨팅.',
  tooltipPlayTime: '플레이 시간 - AI 제국을 구축한 기간.',
  tooltipSettings: '설정 - 디버그 옵션, 게임 리셋',

  // Share
  shareButton: '공유',
  shareText: 'GPT Clicker에서 AI 제국을 구축 중입니다! {users} 사용자, {money} 수익, {model} 훈련 중. {time}에 나를 이길 수 있나요?',
  shareCopied: '텍스트 복사됨!',
  imageCopied: '이미지 복사됨!',
  shareChallenge: '나를 이길 수 있나요?',
  shareTitle: '진행 상황 공유',
  shareDownload: '이미지 저장',
  model: '모델',

  // Feedback
  feedback: '피드백',
  feedbackTitle: '피드백 전송',
  feedbackPlaceholder: 'GPT Clicker에 대해 어떻게 생각하는지 알려주세요...',
  feedbackEmailPlaceholder: '이메일 (선택사항)',
  feedbackSend: '전송',
  feedbackSending: '전송 중...',
  feedbackSuccess: '피드백을 주셔서 감사합니다!',
  feedbackError: '피드백 전송 오류. 다시 시도하세요.',
  feedbackRateLimit: '요청이 너무 많습니다. 더 많은 피드백을 보내기 전에 기다리세요.',
  feedbackClose: '닫기',

  // Console messages
  consoleGameLoaded: '저장에서 게임 로드됨',
  consoleGameSaved: '게임 저장됨',
  consoleFailedToSave: '게임 저장 실패:',
  consoleFailedToLoad: '게임 로드 실패:',
  consoleFailedToClear: '저장 지우기 실패:',

  // Victory
  victoryTitle: '축하합니다!',
  victorySubtitle: '인류 문명이 특이점에 도달했습니다',
  victoryTime: '특이점까지의 시간',
  victoryCta: 'Singularity Clicker를 만들어야 할까요? 소셜 미디어에 댓글을 남겨주세요!',
  victoryClose: '계속 플레이',
}
